import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconVideoCamera = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={12}
    fill="none"
    viewBox="0 0 14 12"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#FF0004"
      fillOpacity={0.8}
      d="M7.563 5.625a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.562H2.688a.542.542 0 0 1-.562-.563c0-.304.234-.562.563-.562h4.874Zm5.742-1.336a.905.905 0 0 1 .445.774v4.875a.914.914 0 0 1-.445.796.962.962 0 0 1-.516.164c-.117 0-.258-.046-.375-.093L10 9.68v.07c0 .844-.68 1.5-1.5 1.5l-6.75-.047c-.844 0-1.5-.656-1.5-1.476V5.25c0-.68.469-1.266 1.125-1.43V2.813c0-1.126.914-2.063 2.063-2.063h3.75a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.562h-3.75a.925.925 0 0 0-.937.938v.937h6c.82 0 1.5.68 1.5 1.5v.07l2.414-1.101a.87.87 0 0 1 .89.07ZM8.875 9.75v-4.5a.403.403 0 0 0-.375-.375H1.75a.385.385 0 0 0-.375.375v4.5c0 .21.164.375.375.375H8.5a.385.385 0 0 0 .375-.375Zm3.75-.094V5.367L10 6.563V8.46l2.625 1.195Z"
    />
  </svg>
));
export default SvgIconVideoCamera;
